import AuditLogTable from "./auditLogTable";

export default AuditLogTable;
